Customer.Conversation ||= {}
Customer.Conversation.Attachments ||= {}

class Customer.Conversation.Attachments.GeneralAttachmentsView extends Backbone.View

  events:
    'change #direct-attachments-files': 'onSelectFile'

  initialize: (@options = {}) ->
    @imageFiles = [] # File objects
    @imageUrls = [] # base64 encoded strings
    @imagePreviewViews = [] # Backbone Views
    @gifFiles = [] # File objects
    @gifUrls = [] # base64 encoded strings
    @gifPreviewViews = [] # Backbone Views
    @videoFiles = [] # File objects
    @videoUrls = [] # base64 encoded strings
    @videoPreviewViews = [] # Backbone Views
    @canAddImages = true
    @canAddGifs = true
    @canAddVideos = true

  render: ->
    @$el.html(@template)

  allFiles: ->
    @imageFiles.concat(@gifFiles).concat(@videoFiles)

  onSelectFile: (event) ->
    return unless event.currentTarget.files[0]
    fileType = event.currentTarget.files[0].type.split('/')[0]
    fileSubtype = event.currentTarget.files[0].type.split('/')[1]

    if fileType == 'image'
      if fileSubtype == 'gif'
        @onSelectGif(event)
      else
        @onSelectImage(event)
    else if fileType == 'video'
      @onSelectVideo(event)
    @resetFilesInput()



  onSelectImage: (evt) ->
    # evt.currentTarget is the input element with type="file" (input)
    input = evt.currentTarget
    # input.files is a FileList (fileList)
    fileList = input.files
    # fileList[0] is a File (file) (or undefined if the user clicked cancel)
    file = fileList[0]
    # file has the following properties:
    #   - lastModified (timestamp)
    #   - lastModifiedDate
    #   - name (string, eg my_image.png)
    #   - size (int)
    #   - type (string, eg image/jpeg)
    @imageFiles.push(file)
    valid = @validateSelectedImage(file)
    @readImage(file) if valid
    @disableAddFiles()

  onSelectGif: (evt) ->
    input = evt.currentTarget
    fileList = input.files
    file = fileList[0]
    @gifFiles.push(file)
    valid = @validateSelectedGif(file)
    @readGif(file) if valid
    @disableAddFiles()

  onSelectVideo: (evt) ->
    input = evt.currentTarget
    fileList = input.files
    file = fileList[0]
    @videoFiles.push(file)
    valid = @validateSelectedVideo(file)
    @readVideo(file) if valid
    @disableAddFiles()

  validateSelectedImage: (file) ->
    extension = file.name.substr(file.name.lastIndexOf(".")).toLowerCase()
    if @canAddImages && _.contains([".jpg", ".jpeg", ".png"], extension)
      valid = true
    else
      swal({
        title: I18n.t('customer.dashboard.conversations.details.response.attachment.error.title_exceeded'),
        text: I18n.t('customer.dashboard.conversations.details.response.attachment.error.image')
        type: 'error'
      })
      valid = false

  validateSelectedGif: (file) ->
    extension = file.name.substr(file.name.lastIndexOf(".")).toLowerCase()
    if @canAddGifs && _.contains([".gif"], extension)
      valid = true
    else
      swal({
        title: I18n.t('customer.dashboard.conversations.details.response.attachment.error.title_exceeded')
        text: I18n.t('customer.dashboard.conversations.details.response.attachment.error.gif')
        type: 'error'
      })
      valid = false

  validateSelectedVideo: (file) ->
    extension = file.name.substr(file.name.lastIndexOf(".")).toLowerCase()
    if @canAddVideos && _.contains([".mp4"], extension)
      valid = true
    else
      swal({
        title: I18n.t('customer.dashboard.conversations.details.response.attachment.error.title_exceeded')
        text: I18n.t('customer.dashboard.conversations.details.response.attachment.error.video')
        type: 'error'
      })
      valid = false

  readImage: (file) ->
    reader = new FileReader
    reader.onload = @addImage # binds the 'loadend' event
    reader.readAsDataURL(file) # triggers the 'loadend' event when finished

  readGif: (file) ->
    reader = new FileReader
    reader.onload = @addGif # binds the 'loadend' event
    reader.readAsDataURL(file) # triggers the 'loadend' event when finished

  readVideo: (file) ->
    reader = new FileReader
    reader.onload = @addVideo # binds the 'loadend' event
    reader.readAsDataURL(file) # triggers the 'loadend' event when finished

  addImage: (evt) =>
    imageUrl = evt.target.result # the file's data as a base64 encoded string
    @addImageUrl(imageUrl)

  addGif: (evt) =>
    gifUrl = evt.target.result # the file's data as a base64 encoded string
    @addGifUrl(gifUrl)

  addVideo: (evt) =>
    videoUrl = evt.target.result # the file's data as a base64 encoded string
    @addVideoUrl(videoUrl)

  addImageUrl: (imageUrl) =>
    @imageUrls.push(imageUrl)
    previewView = new Customer.Conversation.Attachments.AttachmentImagePreviewView(attachment: imageUrl)
    @options.previewsContainer.append(previewView.render().el)
    @listenTo(previewView, 'remove-attachment', @removeImage)
    @imagePreviewViews.push(previewView)
    @updateAddAttachmentButtonsStatus()

  addGifUrl: (gifUrl) =>
    @gifUrls.push(gifUrl)
    previewView = new Customer.Conversation.Attachments.AttachmentImagePreviewView(attachment: gifUrl)
    @options.previewsContainer.append(previewView.render().el)
    @listenTo(previewView, 'remove-attachment', @removeGif)
    @gifPreviewViews.push(previewView)
    @updateAddAttachmentButtonsStatus()

  addVideoUrl: (videoUrl) =>
    @videoUrls.push(videoUrl)
    previewView = new Customer.Conversation.Attachments.AttachmentVideoPreviewView(attachment: videoUrl)
    @options.previewsContainer.append(previewView.render().el)
    @listenTo(previewView, 'remove-attachment', @removeVideo)
    @videoPreviewViews.push(previewView)
    @updateAddAttachmentButtonsStatus()

  removeImage: (imageUrl) ->
    index = @imageUrls.indexOf(imageUrl)
    if index > -1 # should always happen
      @imageUrls.splice(index, 1)
      @imageFiles.splice(index, 1)
      @imagePreviewViews[index].remove()
      @imagePreviewViews.splice(index, 1)

    if @imageFiles.length == 0
      @enableAddFiles()
    else
      @canAddImages = true
    @updateAddAttachmentButtonsStatus()
    @triggerRemoveAttachment()

  removeGif: (gifUrl) ->
    index = @gifUrls.indexOf(gifUrl)
    if index > -1 # should always happen
      @gifUrls.splice(index, 1)
      @gifFiles.splice(index, 1)
      @gifPreviewViews[index].remove()
      @gifPreviewViews.splice(index, 1)
    @enableAddFiles()
    @triggerRemoveAttachment()
    @updateAddAttachmentButtonsStatus()

  removeVideo: (videoUrl) ->
    index = @videoUrls.indexOf(videoUrl)
    if index > -1 # should always happen
      @videoUrls.splice(index, 1)
      @videoFiles.splice(index, 1)
      @videoPreviewViews[index].remove()
      @videoPreviewViews.splice(index, 1)
    @enableAddFiles()
    @triggerRemoveAttachment()
    @updateAddAttachmentButtonsStatus()

  updateAddAttachmentButtonsStatus: ->
    @$el.find('#add-direct-attachment-file-btn').toggleClass(
      'disabled',
      not (@canAddImages || @canAddVideos || @canAddGifs)
    )

  triggerRemoveAttachment:->
    @trigger('remove:attachment')

  resetFilesInput: () ->
    if !@canAddImages || !@canAddVideos || !@canAddGifs
      fileInput = @$el.find('#direct-attachments-files')
      fileInput.replaceWith(fileInput.val('').clone(true))

  enableAddFiles: () ->
    @canAddImages = @imageFiles.length <= 3
    @canAddGifs = true
    @canAddVideos = true

  disableAddFiles: () ->
    @canAddImages = false
    @canAddGifs = false
    @canAddVideos = false
